import { Tooltip } from "@material-ui/core";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export default function CustomTabs({
  tabs,
  active,
  setActive,
  onChange = null,
}) {
  const [positions, setPositions] = useState({});

  const containerRef = useRef(null);

  // Recalculate positions when tabs or active change
  useEffect(() => {
    if (containerRef.current) {
      const newPositions = {};
      const children = containerRef.current.children;

      for (let child of children) {
        if (child.dataset.key) {
          newPositions[child.dataset.key] = {
            left: child.offsetLeft,
            width: child.offsetWidth,
          };
        }
      }

      setPositions(newPositions);
    }
  }, [active, tabs]);

  if (!tabs || tabs.length === 0) {
    return null;
  }

  const handleClick = (event, key) => {
    if (onChange) onChange(event, key);
    else setActive(key);
  };

  const compactClasses = "px-2 py-1.5 text-xs";
  const indicatorCompactClasses = "top-0.5 bottom-0.5";

  return (
    <div
      ref={containerRef}
      className="relative flex items-center bg-[#e2e8f0] border border-[#cbd5e1] rounded-md p-0.5 gap-1"
      style={{
        height: "32px",
      }}
    >
      {positions[active] && (
        <motion.div
          className={`absolute bg-[#313C4C] shadow-none rounded-md ${indicatorCompactClasses}`}
          initial={false}
          animate={{
            left: positions[active].left,
            width: positions[active].width,
          }}
          transition={{ type: "spring", stiffness: 400, damping: 30 }}
        />
      )}

      {tabs.map(({ label, key, tooltip, ...rest }) =>
        tooltip ? (
          <Tooltip
            key={key}
            title={<span className="text-[11px]">{tooltip}</span>}
            arrow
          >
            <button
              data-key={key}
              {...rest}
              onClick={(e) => handleClick(e, key)}
              className={`relative z-10 font-medium rounded-md transition-all capitalize duration-200 whitespace-nowrap h-fit ${compactClasses}
              ${active === key
                  ? "text-white font-medium"
                  : "text-gray-700 hover:text-gray-900"
                }`}
            >
              {label}
            </button>
          </Tooltip>
        ) : (
          <button
            key={key}
            data-key={key}
            {...rest}
            onClick={(e) => handleClick(e, key)}
            className={`relative z-10 font-medium rounded-md transition-all duration-200 whitespace-nowrap h-fit ${compactClasses}
            ${active === key
                ? "text-white font-medium"
                : "text-gray-700 hover:text-gray-900"
              }`}
          >
            {label}
          </button>
        )
      )}
    </div>
  );
}
